import React, { useState } from 'react';
import { Container, ThisCard } from './styles';

import IconProdutosAtivo from '~/assets/icones/IconProdutosAtivo.svg';
import IconProdutosAtivoB from '~/assets/icones/IconProdutosAtivoB.svg';

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);

  return (
    <Container>
      {data?.map((thisData, i) => (
        <ThisCard
          className={
            linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'
          }
          {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
          key={thisData?.id || i}
          id={thisData?.id || i}
          index={i}
          ativo={linhaAtiva === thisData?.id ? true : false}
        >
           <div className="card-body">
            <div className="card-text">
              <p className="descricao">#{thisData?.codigo}</p>
              <p className="titulo">{thisData?.perfil?.usuario?.nome}</p>
            </div>
          </div>
          <div className="card">
            <img src={localStorage.getItem("tema") == "E" ? IconProdutosAtivo : IconProdutosAtivoB} alt="Vazio" />
          </div>
        </ThisCard>
      ))}
    </Container>
  );
}

export default CustomBodyContent;
